<template>
    <v-card flat class="sub-site-wrapper">
        <div class="chart-component-wrapper">
            <div class="chart-controls">
                <v-btn-toggle variant="outlined" rounded="lg" v-model="chartType">
                    <v-btn value="bar">Bar</v-btn>
                    <v-btn value="line">Line</v-btn>
                    <v-btn value="area">Area</v-btn>
                    <v-btn value="pie">Pie</v-btn>
                </v-btn-toggle>
            </div>
            <div>
                <apexchart v-if="!loading" :key="chartType" :type="chartType" height="400" :options="chartOptions"
                    :series="chartSeries">
                </apexchart>
            </div>
        </div>
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VueApexCharts from 'vue3-apexcharts';

export default {
    components: {
        apexchart: VueApexCharts
    },
    created() {
        this.loadStatistics();
    },
    data() {
        return {
            chartType: 'bar'  // Default chart type
        };
    },
    computed: {
    ...mapState('statistics', ['agencyStats', 'loading', 'statisticsAge']),
    chartSeries() {
      if (!this.agencyStats || !this.agencyStats.slotsDistribution) return [];
      const slotsDistribution = this.agencyStats.slotsDistribution;
      const values = Object.entries(slotsDistribution).map(([slots, count]) => count * slots * 15);
      // Handle series format for pie chart separately
      return this.chartType === 'pie'
        ? values
        : [{
            name: 'Total Value (€)',
            data: values
          }];
    },
    chartOptions() {
      if (!this.agencyStats || !this.agencyStats.slotsDistribution) return {};
      const slotsDistribution = this.agencyStats.slotsDistribution;
      const categories = Object.keys(slotsDistribution);
      return {
        chart: {
          type: this.chartType  // Use dynamic chart type
        },
        colors: this.chartType === 'pie' ? ['#783597', '#FF5733', '#C70039', '#900C3F', '#581845', '#FFC300', '#DAF7A6', '#FF5733', '#C70039', '#900C3F', '#581845', '#56BAEC', '#B6D7F2', '#8A2BE2', '#7FFF00', '#D2691E'] : ['#783597'],
        xaxis: this.chartType !== 'pie' ? {
          categories: categories
        } : undefined,
        labels: this.chartType === 'pie' ? categories : [],
        plotOptions: {
          bar: {
            horizontal: false,
          }
        },
        dataLabels: {
          enabled: false
        },
        title: {
          text: 'Wert der Slot-Brackets, bei 15€ pro Slot',
          align: 'center'
        }
      };
    }
  },
  methods: {
    ...mapActions('statistics', ['fetchMostRecentStatistic']),
    async loadStatistics() {
      await this.fetchMostRecentStatistic();
    }
  }
};
</script>

<style lang="scss" scoped>
.table-statistics-wrapper {
    padding: 24px;
}

.statistics-text-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: 500;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    padding: 12px;
}

.statistics-text-box p {
    font-weight: 400;
    font-size: 14px;
}

.chart-controls {
    margin-bottom: 20px;
}
</style>